/* eslint-disable */
import Vue from 'vue';
import PrimeVue from 'primevue/config';
import ShardsVue from 'shards-vue';
import VueAnalytics from 'vue-analytics';
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap'

// Styles
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/theme/s2p-dashboard.scss';
import '@/assets/scss/date-range.scss';
import '@/assets/scss/date-range-provider.scss';


// Core
import App from './App.vue';
import router from './router';
import store from './store';

// Plugin Vue
import VueCurrencyInput from 'vue-currency-input'
import VueTheMask from 'vue-the-mask'
import "./vee-validate";

// Plugin Utils
import './utils/filters.js'
import msgbox from './utils/msgBox.js'
import requestGetCommissionCompetence from './utils/requestGetCommissionCompetence.js'
import sessionStoreAuth from './utils/sessionStoreAuth.js'
import toast from './utils/toast.js'
import accessPermission from './utils/accessPermission.js'

// Layouts
import Default from '@/layouts/Default.vue';
import HeaderNavigation from '@/layouts/HeaderNavigation.vue';
import IconSidebar from '@/layouts/IconSidebar.vue';

// Custom Components
import Loader from './components/common/Loader.vue'

import * as VueGoogleMaps from 'vue2-google-maps'
//import GmapCluster from 'vue2-google-maps/src/components/cluster' 
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

const isProd = process.env.NODE_ENV === 'production';

Vue.use(PrimeVue);
ShardsVue.install(Vue);

Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(msgbox)
Vue.use(requestGetCommissionCompetence)
Vue.use(sessionStoreAuth)
Vue.use(toast)
Vue.use(accessPermission)

Vue.component('Loader', Loader);
Vue.component('default-layout', Default);
Vue.component('header-navigation-layout', HeaderNavigation);
Vue.component('icon-sidebar-layout', IconSidebar);
Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: 'BRL',
    distractionFree: false
  }
})

// Analytics
Vue.use(VueAnalytics, {
  id: isProd ? 'UA-115105611-1' : 'UA-115105611-2',
  router
});


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAuki-W3LZuti1rp1cn8GhkmJc-qiJrjlg',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});


Vue.component('google-marker', VueGoogleMaps.Marker);
Vue.component('GmapCluster', GmapCluster) 




new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js